module.exports = __webpack_public_path__ + "img/ubercart7.9adea061.png";